var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFlyingMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 202 162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M200.836 57.298l-.486.116a5.52 5.52 0 01-3.028 6.278h0l-78.84 36.995h0a5.513 5.513 0 01-6.65-1.538 5.51 5.51 0 01-1.066-2.18l-10.481-51.654-.002-.009-.002-.008a5.524 5.524 0 013.026-6.278h0l78.841-36.995h.001a5.513 5.513 0 016.65 1.538 5.537 5.537 0 011.066 2.18l10.481 51.655.49-.1z",
    fill: "#fff",
    stroke: "#3A3544"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M200.836 57.296a6.025 6.025 0 01-3.3 6.849l-78.841 36.987a6.015 6.015 0 01-7.253-1.678 6.019 6.019 0 01-1.165-2.385L99.793 45.416a6.021 6.021 0 013.3-6.848L181.934 1.58a6.013 6.013 0 017.253 1.678 6.03 6.03 0 011.164 2.385l10.485 51.653z",
    stroke: "#3A3544",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M143.609 51.887a12.04 12.04 0 0012.148-4.76l30.049-45.972a6.014 6.014 0 00-3.882.425l-78.83 36.988a5.994 5.994 0 00-2.661 2.45l43.176 10.87z",
    fill: "#fff",
    stroke: "#3A3544",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.634 100.01l34.998-16.415M47.698 119.335l43.427-20.367M29.031 127.981l8.261-3.878M16.638 133.794l2.069-.971M23.575 114.546l2.065-.971M33.867 94.448l2.065-.967M35.965 108.732l8.264-3.876M66.868 79.916l22.605-10.602M46.256 88.635l8.264-3.875M135.12 49.751l-21.601 51.354M160.3 40.178l40.658 19.206",
    stroke: "#3A3544",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M139.457 136.681l.49-.099-.487.115a2.51 2.51 0 01-1.376 2.855h-.001l-39.42 18.498h0a2.506 2.506 0 01-3.507-1.687l-5.24-25.823-.002-.008-.002-.008a2.51 2.51 0 011.376-2.855h0l39.421-18.498h.001a2.499 2.499 0 012.157.011 2.504 2.504 0 011.35 1.676l5.24 25.823z",
    fill: "#fff",
    stroke: "#3A3544"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M139.947 136.581a3.01 3.01 0 01-1.65 3.424l-39.42 18.494a3.02 3.02 0 01-2.589-.013 3.016 3.016 0 01-1.62-2.019l-5.243-25.826a3.013 3.013 0 011.65-3.425l39.421-18.493a3 3 0 013.626.839 3 3 0 01.583 1.192l5.242 25.827z",
    stroke: "#3A3544",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M111.334 133.876a6.019 6.019 0 006.074-2.38l15.025-22.986a3.006 3.006 0 00-1.941.213l-39.415 18.493a3 3 0 00-1.33 1.226l21.587 5.434z",
    fill: "#fff",
    stroke: "#3A3544",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M75.394 156.203l11.551-5.418M65.17 161l.682-.32M53.351 158.188l.682-.32M69.26 159.082l2.729-1.279M63.576 153.392l21.536-10.066M57.44 156.269l2.73-1.279M107.089 132.808l-10.8 25.677M119.679 128.021l20.329 9.604",
    stroke: "#3A3544",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M83.16 47.34l.49-.1-.486.116a2.512 2.512 0 01-1.377 2.854h0l-39.42 18.498h0a2.506 2.506 0 01-3.508-1.686l-5.24-25.824-.002-.008-.001-.008a2.512 2.512 0 011.376-2.855h0l39.42-18.497h0a2.508 2.508 0 013.508 1.686l5.24 25.823z",
    fill: "#fff",
    stroke: "#3A3544"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M83.65 47.239A3.012 3.012 0 0182 50.663L42.58 69.157a3.007 3.007 0 01-4.21-2.032L33.128 41.3a3.012 3.012 0 011.65-3.424l39.42-18.494a3.007 3.007 0 014.21 2.032l5.242 25.826z",
    stroke: "#3A3544",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M55.037 44.535a6.02 6.02 0 006.074-2.38l15.024-22.987a3.008 3.008 0 00-1.94.213L34.78 37.875a3 3 0 00-1.331 1.225l21.588 5.434z",
    fill: "#fff",
    stroke: "#3A3544",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3 70.965l20.348-9.522M1 75.331l.682-.32M7.232 61.014l.682-.32M5.09 73.412l2.728-1.28M17.456 56.218l7.46-3.5M11.321 59.095l2.73-1.279M50.792 43.466l-10.8 25.677M63.382 38.68l20.33 9.603",
    stroke: "#3A3544",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgFlyingMail;